import { AuthType } from '@bg-shared/business/Auth/enums';
import { storageRepository, uaParser } from '@betgames/bg-tools';
import { httpClientRepository } from '@bg-shared/infrastructure/HttpClient';

export default class AuthConfig {
    private playerID: number = null;

    private readonly HTTP_HEADERS = {
        auth: 'Authorization',
        locale: 'Locale',
        mobile: 'Mobile',
    };

    private readonly refUrl = encodeURIComponent(
        window.location !== window.parent.location ? document.referrer : '',
    );

    private readonly keys = {
        type: `authType:${this.refUrl}`,
        query: `authQuery:${this.refUrl}`,
    };

    // TODO: remove legacy fallback
    private type: AuthType = Number(
        storageRepository.getItem(this.keys.type) || storageRepository.getItem('authType'),
    );

    // TODO: remove legacy fallback
    private query: string =
        storageRepository.getItem(this.keys.query) || storageRepository.getItem('authQuery');

    public get authType() {
        return this.type;
    }

    public get authQuery() {
        return this.query;
    }

    public setConfig(type: AuthType, query: string) {
        this.type = type;
        this.query = query;

        storageRepository.setItem(this.keys.type, type.toString());
        storageRepository.setItem(this.keys.query, query);
    }

    public setHeaders(token: string, locale: string): void {
        httpClientRepository.setHeaders({
            [this.HTTP_HEADERS.auth]: token,
            [this.HTTP_HEADERS.locale]: locale,
            [this.HTTP_HEADERS.mobile]: Number(uaParser.isMobile).toString(),
        });
    }

    public clearHeaders(): void {
        httpClientRepository.removeHeader(this.HTTP_HEADERS.auth);
    }

    public get PlayerID(): number {
        return this.playerID;
    }

    public setPlayerID(value: number) {
        this.playerID = value;
    }
}

export const authConfig = new AuthConfig();
